import React, {useState} from 'react';
import Card from "../components/card/card";
import Filter from "../components/filter";
import CoverLoading from "../components/cover-loading";
import {Link} from "react-router-dom";


const OtherTours = () => {
    const [post,setPost] = useState([])
    const [loading,setLoading] = useState(false)
    return (
        <div className='main-container justify-content-start'>
            {loading ? <CoverLoading/> : ''}
            <Filter path='other-tour' setPost={setPost} setLoading={setLoading}/>
            <div className="row justify-content-end">
                <div className="col-2">
                    <Link to={'/add-other-tour'} className='btn btn-primary'>Create Europe Tour</Link>
                </div>
            </div>
            <div className="list-posts">
                {post.map((e)=><Card path='other-tour' post={post} setPost={setPost} setLoading={setLoading} key={e.id} data={e}/>)}
            </div>
        </div>
    );
};

export default OtherTours